import {api} from './api';
import {SWAP_TOKEN_URL_PATH} from '../constants';

export interface UserInfo {
	id: string;
	name: string;
	companyName: string;
}

interface UpdateCurrentAccountRequest {
	name: string;
}

interface SwapTokenRequest {
	auth0Token: string;
}

interface SwapTokenResponse {
	token: string;
}

export const accountsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		swapToken: builder.mutation<SwapTokenResponse, SwapTokenRequest>({
			query: ({ auth0Token }) => ({
				url: SWAP_TOKEN_URL_PATH,
				method: 'POST',
				body: {
					auth0Token,
				},
			}),
			extraOptions: { maxRetries: 1 }
		}),
		getUserInfo: builder.mutation<UserInfo, void>({
			query: () => ({
				url: 'accounts/userInfo',
				method: 'GET',
			}),
			extraOptions: { maxRetries: 1 }
		}),
		updateCurrentAccount: builder.mutation<UserInfo, UpdateCurrentAccountRequest>({
			query: ({ name }) => ({
				url: 'accounts/current',
				method: 'PUT',
				body: { name },
			}),
			extraOptions: { maxRetries: 1 }
		}),
	}),
});

export const { useSwapTokenMutation, useGetUserInfoMutation, useUpdateCurrentAccountMutation } = accountsApi;
